module.exports = __webpack_public_path__ + "img/4u_icon.c91e6af0.png";